var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialProductNewSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 20.7286C16.6995 20.7286 20.0567 19.066 20.0567 15.3654C20.0567 11.3431 18.0424 8.66147 14.0138 6.65029L15.5984 4.61227C15.6789 4.47857 15.7225 4.32598 15.7249 4.16998C15.7274 4.01398 15.6884 3.86012 15.6121 3.724C15.5357 3.58787 15.4247 3.47432 15.2902 3.39486C15.1558 3.31539 15.0026 3.27282 14.8464 3.27148H9.15267C8.99641 3.27282 8.8433 3.31539 8.70884 3.39486C8.57437 3.47432 8.46334 3.58787 8.387 3.724C8.31064 3.86012 8.2717 4.01398 8.2741 4.16998C8.27651 4.32598 8.32016 4.47857 8.40067 4.61227L9.98524 6.66369C5.95667 8.68829 3.94238 11.3699 3.94238 15.3923C3.94238 19.066 7.29953 20.7286 11.9995 20.7286Z",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8562 11.7394C13.7923 11.5587 13.6938 11.3944 13.5685 11.2545C13.3022 10.9568 12.915 10.7695 12.4842 10.7695H11.3582C10.641 10.7695 10.0596 11.3509 10.0596 12.0681C10.0596 12.6783 10.4845 13.2063 11.0807 13.3367L12.7951 13.7117C13.4629 13.8578 13.939 14.4496 13.939 15.1333C13.939 15.9368 13.2876 16.5887 12.4842 16.5887H11.5143C10.8809 16.5887 10.3421 16.1838 10.1424 15.6188",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.7692V9.31445",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.0432V16.5884",
    stroke: "#643DD6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialProductNewSelected);
export default __webpack_public_path__ + "static/media/FinancialProductNewSelected.847121a1600310d42172dcc4b26878d9.svg";
export { ForwardRef as ReactComponent };